import React, { useContext, useEffect, useState } from "react";

import { Spin } from "antd";
import axios from "axios";
import { Card } from "react-bootstrap";
import PsContext from "../../../context";
import { ServiceUrl } from "../../../utils/serviceUrl";

const Announcement = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    let url = ServiceUrl.ADMISSION.ANNOUNCEMENTS;

    axios.get(url).then((res) => {
      if (res["data"].status == "1") {
        setDataList(res["data"].data);
      }
      setLoader(false);
    });
  };

  const marqueeMouseOver = () => {
    document.getElementById("adm_top_marquee").stop();
  };

  const marqueeMouseOut = () => {
    document.getElementById("adm_top_marquee").start();
  };

  const renderHtmlText = () => {
    return dataList.map((item) => (
      <li style={{ display: "inline-block " }}>
        <div
          className="px-4"
          dangerouslySetInnerHTML={{ __html: item.content_html }}
        />
      </li>
    ));
  };

  return (
    <>
      <Card className="rounded card-border-btm">
        <Card.Header className="fw-bold">Announcements</Card.Header>
        <Card.Body>
          <Spin spinning={loader}>
            <marquee
              onMouseOver={marqueeMouseOver}
              onMouseOut={marqueeMouseOut}
              id="adm_top_marquee"
              direction="up"
              scrollamount="4"
              style={{ height: "54vh" }}
            >
              <ul className="top_marquee px-0 py-0 mx-0 my-0">
                {renderHtmlText()}
              </ul>
            </marquee>
          </Spin>
        </Card.Body>
      </Card>
    </>
  );
};

export default Announcement;
